module.exports = __webpack_public_path__ + "static/media/dmg.698cbba3.png";